import { useState } from "react";
import { formatTime } from "../../lib/utils";
import { ActivityFragment } from "../../__generated__/graphql";
import { Icon } from "../Icon";
import { ActivityDetailsModal } from "../ActivityDetailsModal";
import ParticipantsAvatars from "../ParticipantsAvatars";
import DraftBadge from "../DraftBadge";

interface ActivityCardProps {
  activity: ActivityFragment;
  isDraft?: boolean;
}

export default function ActivityCard({
  activity,
  isDraft = false,
}: ActivityCardProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const participants = activity.activityParticipants || [];

  const location = activity.activityLocation?.location;
  const addressParts = [
    location?.address,
    // location?.zipCode,
    // location?.city,
  ].filter(Boolean);
  const fullAddress = addressParts.join(", ");

  return (
    <>
      <ActivityDetailsModal
        activityId={activity.id}
        eventId={activity.eventId ?? null}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      <div
        className="flex flex-col gap-2 w-full bg-card rounded-md cursor-pointer hover:bg-card/50 transition-all duration-300 border border-border p-3 relative"
        style={{
          borderLeftColor: activity.color,
          borderLeftWidth: "4px",
        }}
        onClick={() => setIsModalOpen(true)}
      >
        <div className="flex items-center gap-2 justify-between">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <div className="text-sm text-secondary">
              {formatTime(activity.startDate)}{" "}
              {activity.endDate ? `- ${formatTime(activity.endDate)}` : ""}
            </div>
            {isDraft && (
              <DraftBadge variant="small" className="whitespace-nowrap" />
            )}
          </div>

          <ParticipantsAvatars
            participants={participants}
            className="ml-2"
            maxDisplayed={20}
          />
        </div>

        <div className="flex items-center gap-2 flex-1 min-w-0">
          <Icon icon={activity.icon} className="w-5 h-5 flex-shrink-0" />
          <div className="text-lg font-semibold text-primary truncate">
            {activity.title}
          </div>
        </div>

        {activity.description && (
          <div className="text-sm text-secondary">{activity.description}</div>
        )}

        {fullAddress && (
          <div className="text-sm text-secondary">{fullAddress}</div>
        )}
      </div>
    </>
  );
}
